<div class="chips-filter" [class.chips-filter--outlined]="outlined()">
  @if (outlined() && label()) {
    <span class="chips-filter__label">{{ label() }}</span>
  }
  <div class="example-chip-list">
    <mat-chip-grid #chipList class="example-chip-list__chip-list">
      @for (item of selectedItems(); let i = $index; track item.label + '_' + i) {
        <mat-chip-row (removed)="remove(item, i)">
          <div class="example-chip-list__value" [matTooltip]="item.label">{{ item.label }}</div>
          @if (!disabled()) {
            <button matChipRemove>
              <mat-icon class="example-chip-list__delete">cancel</mat-icon>
            </button>
          }
        </mat-chip-row>
      }
      @if (!disabled()) {
        <div class="example-chip-list__input-container">
          <input
            class="example-chip-list__input"
            #itemInput
            placeholder="Add Item"
            [formControl]="ctrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (focus)="updatePanelWidth()"
          />
        </div>
      }
    </mat-chip-grid>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selected($event)"
      [panelWidth]="currentPanelWidth"
    >
      @for (item of filteredItems(); let i = $index; track item.item + '_' + i) {
        <mat-option [value]="item.item">
          {{ item.label }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
  @if (!disabled()) {
    <mat-icon class="dropdown-arrow" (click)="focusInput()">arrow_drop_down</mat-icon>
  }
</div>
